// App.js
import React from 'react';
import EarthAtmosphere from './components/atmosphere';

function App() {
  return (
    <div style={{ backgroundColor: 'black'}}>
      <EarthAtmosphere />
    </div>
  );
}

export default App;